module.exports = __webpack_public_path__ + "static/img/lb.450d593.png";


//////////////////
// WEBPACK FOOTER
// ./static/xd/lb.png
// module id = Vnia
// module chunks = 0